/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ProgrammingAssignmentIcon = /*#__PURE__*/ createSvgIcon(
  'ProgrammingAssignmentIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.02 10.02l3.23 3.23a.79.79 0 01.23.583.79.79 0 01-.23.584.79.79 0 01-.583.229.79.79 0 01-.584-.23L2.25 10.584a.731.731 0 01-.177-.27A.922.922 0 012.02 10c0-.111.017-.215.052-.312a.731.731 0 01.177-.271l3.833-3.834a.811.811 0 01.594-.25c.23 0 .427.084.594.25.166.167.25.365.25.594 0 .23-.084.427-.25.594l-3.25 3.25zm11.96-.04l-3.23-3.23a.79.79 0 01-.23-.583.79.79 0 01.23-.584.79.79 0 01.583-.229.79.79 0 01.584.23l3.833 3.833a.73.73 0 01.177.27.923.923 0 01.052.313.922.922 0 01-.052.313.73.73 0 01-.177.27l-3.833 3.834a.763.763 0 01-.584.24.84.84 0 01-.583-.261.812.812 0 01-.25-.594c0-.229.083-.427.25-.594l3.23-3.229z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ProgrammingAssignmentIcon;
